import { Grid, Typography } from "@mui/material"
import { IOrderPrint } from "../../../models/OrderManagement"

type IProps = {
    data: IOrderPrint
}

const BasicPrintOrderHeader = ({data}: IProps) => {

    return (
        <>
        {data && (

            <>
                <Grid item md={6} display="flex">
                    <Grid>
                        <Grid className="table-header-header">
                            <Typography>{data.dealerContact.name}</Typography>
                        </Grid>
                        <Grid>
                            <Typography ><b>Customer PO :</b> {data.purchaseOrder}</Typography>
                        </Grid>
                        <Grid item zeroMinWidth>
                            <Typography style={{ overflowWrap: 'break-word' }}><b>Delivery :</b> {data.requestedDelivery}</Typography>
                        </Grid>
                        <Grid sx={{mt:1}}>
                            <Typography><b>ORDER # :</b> {data.orderNumber}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} display="flex" justifyContent="flex-end">
                    <Grid>
                        <Typography ><b>Allocation Date : </b>{data.allocationDate}</Typography>
                        <Typography ><b>Terms : </b> {data.termOption}</Typography>
                        <Typography ><b>Freight :</b> {data.shipVia}</Typography>
                    </Grid>
                    
                </Grid>
            
            </>

        )}
        
        </>
    )
}

export default BasicPrintOrderHeader